import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './MTIModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class MTIModal extends Component {
	render() { 
		let royalty = '';
		if (this.props.mti_access_result.royalties) {
			if (this.props.event_type === 'Video On Demand') {
				royalty = this.props.mti_access_result.royalties.streamD || '';
			}
			if (this.props.event_type === 'Scheduled Content') {
				royalty = this.props.mti_access_result.royalties.streamS || '';
			}
			if (this.props.event_type === 'Live Stream') {
				royalty = this.props.mti_access_result.royalties.streamL || '';
			}
		}
		return ( 
			<div>
		  		<Modal
					isOpen={this.props.isShowModal}
					toggle={this.props.toggleModal}
				  	className="showtix-event__modal__mti"
				>
		          	<ModalHeader>{strings.title}</ModalHeader>
		          	<ModalBody>
                        <p>{strings.description}</p>
						<p className="showtix-subtitle">{this.props.mti_access_result.customerName}</p>
                        <p>{strings.description2}</p>
						<p className="showtix-subtitle">{this.props.mti_access_result.showName}.</p>
						<hr />
						<p>{strings.formatString(strings.description3, royalty)}</p>
		          	</ModalBody>
		          	<ModalFooter className="text-center">
						<button 
						  	type="button" 
							className="showtix-button showtix-background__primary-1"
							onClick={() => this.props.acceptRoyalties('Y')}
						>
							<span>{strings.yes}</span>
						</button>
						<button 
						  	type="button" 
							className="showtix-button showtix-background__primary-2"
							onClick={() => this.props.acceptRoyalties('N')}
						>
							<span>{strings.no}</span>
						</button>
		          	</ModalFooter>
		        </Modal>
			</div>
		)
	}
}
 
export default MTIModal;


// WEBPACK FOOTER //
// ./src/components/CreateEvent/MTIModal/MTIModal.js